import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('bill.bill_shared_details_view'),
        action: (obj) => {
          this.handleOpenSidepage(obj, 'bill-shared')
        },
        meta: (obj) => {
          const ret = {
            validate: true,
          }
          if (obj.charge_type !== 'prepaid') {
            ret.validate = false
          }
          return ret
        },
      },
    ]
  },
}
